<template>
  <li class="nav-item">
    <a @click="logout" class="nav-link btn btn-outline-primary" style="padding: 8px;">
      <b-icon icon="power"></b-icon>Αποσύνδεση
    </a>
  </li>
</template>

<script>
export default {
  name: "LogoutButton",
  computed: {
    appUrl() {
      return process.env.VUE_APP_API_URL
    },
  },
  methods: {
    logout() {
      this.$store.dispatch('logoutUser')
    }
  }
}
</script>

<style scoped>
  a:hover {
    color: white !important;
  }
</style>